var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loader',{staticClass:"shop-product",attrs:{"promise":_vm.promises.fetchOne}},[(_vm.item.id)?_c('ProductDetails',{attrs:{"value":{ product: _vm.item }}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }